/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRewardPromotionBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllRewardPromotionsResponse } from '../models';
// @ts-ignore
import type { RewardPromotionResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateRewardPromotionBody } from '../models';
/**
 * RewardPromotionApiApi - axios parameter creator
 */
export const RewardPromotionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRewardPromotionBody} createRewardPromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiCreateRewardPromotion: async (createRewardPromotionBody: CreateRewardPromotionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRewardPromotionBody' is not null or undefined
            assertParamExists('rewardPromotionApiCreateRewardPromotion', 'createRewardPromotionBody', createRewardPromotionBody)
            const localVarPath = `/reward-promotion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRewardPromotionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiDeleteRewardPromotion: async (promotionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionId' is not null or undefined
            assertParamExists('rewardPromotionApiDeleteRewardPromotion', 'promotionId', promotionId)
            const localVarPath = `/reward-promotion/{promotion_id}`
                .replace('{promotion_id}', encodeURIComponent(String(promotionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiGetAllRewardPromotions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reward-promotion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiGetRewardPromotionById: async (promotionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionId' is not null or undefined
            assertParamExists('rewardPromotionApiGetRewardPromotionById', 'promotionId', promotionId)
            const localVarPath = `/reward-promotion/{promotion_id}`
                .replace('{promotion_id}', encodeURIComponent(String(promotionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {UpdateRewardPromotionBody} updateRewardPromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiUpdateRewardPromotion: async (promotionId: string, updateRewardPromotionBody: UpdateRewardPromotionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionId' is not null or undefined
            assertParamExists('rewardPromotionApiUpdateRewardPromotion', 'promotionId', promotionId)
            // verify required parameter 'updateRewardPromotionBody' is not null or undefined
            assertParamExists('rewardPromotionApiUpdateRewardPromotion', 'updateRewardPromotionBody', updateRewardPromotionBody)
            const localVarPath = `/reward-promotion/{promotion_id}`
                .replace('{promotion_id}', encodeURIComponent(String(promotionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRewardPromotionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardPromotionApiApi - functional programming interface
 */
export const RewardPromotionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardPromotionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRewardPromotionBody} createRewardPromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardPromotionApiCreateRewardPromotion(createRewardPromotionBody: CreateRewardPromotionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardPromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardPromotionApiCreateRewardPromotion(createRewardPromotionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardPromotionApiApi.rewardPromotionApiCreateRewardPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardPromotionApiDeleteRewardPromotion(promotionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardPromotionApiDeleteRewardPromotion(promotionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardPromotionApiApi.rewardPromotionApiDeleteRewardPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardPromotionApiGetAllRewardPromotions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllRewardPromotionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardPromotionApiGetAllRewardPromotions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardPromotionApiApi.rewardPromotionApiGetAllRewardPromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardPromotionApiGetRewardPromotionById(promotionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardPromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardPromotionApiGetRewardPromotionById(promotionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardPromotionApiApi.rewardPromotionApiGetRewardPromotionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {UpdateRewardPromotionBody} updateRewardPromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewardPromotionApiUpdateRewardPromotion(promotionId: string, updateRewardPromotionBody: UpdateRewardPromotionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardPromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewardPromotionApiUpdateRewardPromotion(promotionId, updateRewardPromotionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardPromotionApiApi.rewardPromotionApiUpdateRewardPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardPromotionApiApi - factory interface
 */
export const RewardPromotionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardPromotionApiApiFp(configuration)
    return {
        /**
         * 
         * @param {RewardPromotionApiApiRewardPromotionApiCreateRewardPromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiCreateRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiCreateRewardPromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardPromotionResponse> {
            return localVarFp.rewardPromotionApiCreateRewardPromotion(requestParameters.createRewardPromotionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RewardPromotionApiApiRewardPromotionApiDeleteRewardPromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiDeleteRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiDeleteRewardPromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.rewardPromotionApiDeleteRewardPromotion(requestParameters.promotionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiGetAllRewardPromotions(options?: RawAxiosRequestConfig): AxiosPromise<GetAllRewardPromotionsResponse> {
            return localVarFp.rewardPromotionApiGetAllRewardPromotions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RewardPromotionApiApiRewardPromotionApiGetRewardPromotionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiGetRewardPromotionById(requestParameters: RewardPromotionApiApiRewardPromotionApiGetRewardPromotionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardPromotionResponse> {
            return localVarFp.rewardPromotionApiGetRewardPromotionById(requestParameters.promotionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RewardPromotionApiApiRewardPromotionApiUpdateRewardPromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewardPromotionApiUpdateRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiUpdateRewardPromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardPromotionResponse> {
            return localVarFp.rewardPromotionApiUpdateRewardPromotion(requestParameters.promotionId, requestParameters.updateRewardPromotionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rewardPromotionApiCreateRewardPromotion operation in RewardPromotionApiApi.
 */
export interface RewardPromotionApiApiRewardPromotionApiCreateRewardPromotionRequest {
    readonly createRewardPromotionBody: CreateRewardPromotionBody
}

/**
 * Request parameters for rewardPromotionApiDeleteRewardPromotion operation in RewardPromotionApiApi.
 */
export interface RewardPromotionApiApiRewardPromotionApiDeleteRewardPromotionRequest {
    readonly promotionId: string
}

/**
 * Request parameters for rewardPromotionApiGetRewardPromotionById operation in RewardPromotionApiApi.
 */
export interface RewardPromotionApiApiRewardPromotionApiGetRewardPromotionByIdRequest {
    readonly promotionId: string
}

/**
 * Request parameters for rewardPromotionApiUpdateRewardPromotion operation in RewardPromotionApiApi.
 */
export interface RewardPromotionApiApiRewardPromotionApiUpdateRewardPromotionRequest {
    readonly promotionId: string

    readonly updateRewardPromotionBody: UpdateRewardPromotionBody
}

/**
 * RewardPromotionApiApi - object-oriented interface
 */
export class RewardPromotionApiApi extends BaseAPI {
    /**
     * 
     * @param {RewardPromotionApiApiRewardPromotionApiCreateRewardPromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewardPromotionApiCreateRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiCreateRewardPromotionRequest, options?: RawAxiosRequestConfig) {
        return RewardPromotionApiApiFp(this.configuration).rewardPromotionApiCreateRewardPromotion(requestParameters.createRewardPromotionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RewardPromotionApiApiRewardPromotionApiDeleteRewardPromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewardPromotionApiDeleteRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiDeleteRewardPromotionRequest, options?: RawAxiosRequestConfig) {
        return RewardPromotionApiApiFp(this.configuration).rewardPromotionApiDeleteRewardPromotion(requestParameters.promotionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewardPromotionApiGetAllRewardPromotions(options?: RawAxiosRequestConfig) {
        return RewardPromotionApiApiFp(this.configuration).rewardPromotionApiGetAllRewardPromotions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RewardPromotionApiApiRewardPromotionApiGetRewardPromotionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewardPromotionApiGetRewardPromotionById(requestParameters: RewardPromotionApiApiRewardPromotionApiGetRewardPromotionByIdRequest, options?: RawAxiosRequestConfig) {
        return RewardPromotionApiApiFp(this.configuration).rewardPromotionApiGetRewardPromotionById(requestParameters.promotionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RewardPromotionApiApiRewardPromotionApiUpdateRewardPromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewardPromotionApiUpdateRewardPromotion(requestParameters: RewardPromotionApiApiRewardPromotionApiUpdateRewardPromotionRequest, options?: RawAxiosRequestConfig) {
        return RewardPromotionApiApiFp(this.configuration).rewardPromotionApiUpdateRewardPromotion(requestParameters.promotionId, requestParameters.updateRewardPromotionBody, options).then((request) => request(this.axios, this.basePath));
    }
}

